import React, { useEffect, useState } from 'react'
import CommonNavbar from '../components/CommonNavbar/CommonNavbar'
import CommonFooter from '../components/CommonFooter/CommonFooter'
import FeatureAdds from '../components/AllProdutcs/FeatureAdds'
import TractorDetails from '../components/AllProdutcs/TractorDetails'
import RelatedProducts from '../components/ProductDetails/RelatedProducts'
import VendorInfo from '../components/AllProdutcs/VendorInfo'
import { getProductDetails } from '../services/ProductsServices'
import { useParams } from 'react-router-dom'
import ProductsReview from '../components/ProductDetails/ProductsReview'
import IconSection from '../components/IconsSection/IconSection'

const ProfileDetails = () => {
  const [details, setDetails] = useState([])
  const { id } = useParams()
  console.log('details', details)
  const getDetails = async () => {
    const res = await getProductDetails(id)

    setDetails(res)
  }

  useEffect(() => {
    getDetails()
  }, [id])

  return (
    <>
      <CommonNavbar hide_btn='d-none' show_btn='d-block' />
      <div className='bg_clr_light_yellow'>
        <div className='container px-xl-5 pb-5 pt-4'>
          <div className='row flex-column-reverse flex-md-row'>
            <div className='col-lg-3 col-md-4 h-100 position-sticky top-0'>
              <VendorInfo details={details} />
              <FeatureAdds />
            </div>
            <div className='col-lg-9 col-md-8'>
              <TractorDetails details={details} />

              <IconSection />
              <ProductsReview />
            </div>
          </div>
        </div>
      </div>
      {details?.productData?.productType === 'innovative' ? (
        <RelatedProducts heading='Related  ' heading2='Products' />
      ) : (
        <RelatedProducts
          heading='Related Top Machinery '
          heading2='Equipments'
        />
      )}

      <CommonFooter />
    </>
  )
}

export default ProfileDetails
